export default __webpack_public_path__ + "static/char-41-anr-662ad6b309b0c80a6f6797df824f0237.gif";